import styled from 'styled-components';
import Input from 'v3/components/Input';

export const InputNumber = styled(Input)`
  -moz-appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const RoutePointCard = styled.div`
  position: relative;
  z-index: 2;

  &:focus-within {
    z-index: 1000;
  }
`;

export const RouteMapContainer = styled.div`
  position: relative;
  z-index: 1;

  > div {
    height: 530px;
    width: 100%;
  }
`;
